/**
 * Runtime configuration service
 * Provides access to environment-specific configuration injected by the server at runtime
 * This allows the same build to be deployed across different environments
 */

interface RuntimeConfig {
  clientId: string;
  clientTenant: string;
  redirectUri: string;
  appInsightsConnectionString: string;
  spSiteUrl: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

class RuntimeConfigService {
  private config: RuntimeConfig;

  constructor() {
    // Read configuration injected by server
    this.config = window.__RUNTIME_CONFIG__ || {
      clientId: '',
      clientTenant: '',
      redirectUri: '',
      appInsightsConnectionString: '',
      spSiteUrl: '',
    };

    if (!window.__RUNTIME_CONFIG__) {
      console.error('Runtime config not found! Make sure the server is injecting configuration.');
    }
  }

  get clientId(): string {
    return this.config.clientId;
  }

  get clientTenant(): string {
    return this.config.clientTenant;
  }

  get redirectUri(): string {
    return this.config.redirectUri;
  }

  get appInsightsConnectionString(): string {
    return this.config.appInsightsConnectionString;
  }

  get spSiteUrl(): string {
    return this.config.spSiteUrl;
  }
}

// Export singleton instance
export const runtimeConfig = new RuntimeConfigService();
